import React from 'react';
import styled from 'styled-components';
import { CcIcon, CcButton } from '@utp/components-react';
import { Block, Label } from '../..';

const StatusWeekWrap = styled.div``;

const HeadingStatus = styled.div`
  width: 100%;
  background: var(--background-background-UTP);
  border-bottom: 1px solid #e6edf2;
  display: none;

  .button.sc-cc-button {
    background-color: var(--background-background-UTP);
    height: 40px;
    width: 40px;
  }

  .close-container {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 0px 16px;
  }

  .close-container cc-icon {
    color: var(--interaction-detail);
  }

  .status-container cc-icon {
    color: var(--text-text02);
    margin-right: 4px;
  }

  .status-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-flow: column wrap;
  }
`;
interface Props {
  onClose: any;
  status: any;
}
function StatusWeek(props: Readonly<Props>) {
  const { onClose, status } = props;

  return (
    <StatusWeekWrap>
      <HeadingStatus>
        <Block className="close-container">
          <CcButton onClick={onClose}>
            <CcIcon name="x" size={22} />
          </CcButton>
        </Block>
        <Block className="status-container">
          <CcIcon name="calendar" size={22} color="var(--text-text02)" />
          <Label black size={14} text={status} />
        </Block>
      </HeadingStatus>
    </StatusWeekWrap>
  );
}

export default StatusWeek;
